import React from 'react'
import PropTypes from 'prop-types'

import PoiItem from './components/PoiItem'
import { StyledPoiList } from './style'

const PoiList = React.memo(({ pois }) => (
  <StyledPoiList>
    {(pois || []).map(poi => (
      <PoiItem
        key={poi.poiId}
        distanceText={poi.distanceText}
        poiId={poi.poiId}
        poiType={poi.poiType}
        poiTypeId={poi.poiTypeId}
        travelType={poi.travelType}
      />
    ))}
  </StyledPoiList>
))

PoiList.propTypes = {
  pois: PropTypes.arrayOf(
    PropTypes.shape({
      distanceText: PropTypes.string,
      poiId: PropTypes.string,
      poiType: PropTypes.string,
      poiTypeId: PropTypes.number,
      travelType: PropTypes.string,
    }),
  ).isRequired,
}
PoiList.defaultProps = {}

export default PoiList
